import { createContext } from "react";

export const SaveContext = createContext(null);
